import { createSlice } from "@reduxjs/toolkit";
import { ProcessData } from "../models/ProcesssData";

const ProcesssReportInitialState: {
	isLoadingBackground: boolean;
	isLoadingGrid: boolean;
	errorMessage: string;
	notificationMessage: string;
	processes: ProcessData[];
	shiftId: number | null | false;
} = {
	isLoadingBackground: false,
	isLoadingGrid: true,
	processes: [],
	errorMessage: "",
	notificationMessage: "",
	shiftId: false,
};

export const ProcesssReportReducer = createSlice({
	name: "__",
	initialState: ProcesssReportInitialState,
	reducers: {
		setIsLoadingBackground(state, { payload }) {
			state.isLoadingBackground = payload;
		},
		setIsLoadingGrid(state, { payload }) {
			state.isLoadingGrid = payload;
		},
		setProcesses(state, { payload }) {
			state.processes = payload;
		},
		setErrorMessage(state, { payload }) {
			state.errorMessage = payload;
		},
		setNotificationMessage(state, { payload }) {
			state.notificationMessage = payload;
		},
		setShiftId(state, { payload }) {
			state.shiftId = payload;
		},
	},
});
